import { Components, ComponentsProps } from "@thisgorilla/primate-ds";
import { FlexRow } from "../../Styles";

const socialMedia: ComponentsProps.IconButtonProps.IProps["iconType"][] = [
  "WhatsApp",
  "Linkedin",
  "Facebook",
  "TwitterNew",
  "Mail",
];

const SocialShare = () => {
  return (
    <FlexRow $gapInPx={8}>
      {socialMedia.map((social) => (
        <Components.IconButton
          iconType={social}
          size="Large"
          disabled={false}
          kind="Opacity"
          onClick={() => {}}
        />
      ))}
    </FlexRow>
  );
};

export default SocialShare;
